import React from "react";
import * as dc from "dc";
import { ChartTemplate } from "./chartTemplate";
import axios from "axios";
import * as d3 from "d3";
import { css } from "glamor";

//#### Data Table

// Create a data table widget and use the given css selector as anchor. You can also specify
// an optional chart group for this chart to be scoped within. When a chart belongs
// to a specific group then any interaction with such chart will only trigger redraw
// on other charts within the same chart group.

const descChartFunc = (divRef, ndx) => {
    // define chart  dimension
    const dimension = ndx.dimension((d) => d.c100);
    // format the outout to two decimal place
    const f = d3.format(",.0f")
    const nasdaqTable = dc
        .dataTable(divRef)
        .dimension(dimension)
        .group((d) => {
            return "";
        })
        .size(10)
        .columns([
            {
                label: "ID",
                format: function (d) {
                    return d.id;
                },
            },
            {
                label: "Value Chain",
                format: function (d) {
                    return d.valueChain;
                },
            },
            {
                label: "Ticket Size",
                format: function (d) {
                    return f(d.ticketSize);
                },
            },
            {
                label: "Finance Stream ",
                format: function (d) {
                    return d.financeStream;
                },
            },
            {
                label: "Location",
                format: function (d) {
                    return d.county;
                },
            },
            {
        // Specify a custom format for column 'Description' by using a label with a function.
                label: "Description",
                format: function (d) {
                    return d.anonymized_Overview_of_Investment_Opportunities;
                },
            },
        ])
    
        .order(d3.ascending)

        .on("renderlet", function (table) {
            table.selectAll(".dc-table-group").classed("info", true);
        });
    //  utility function 

    const getElementByIdAsync = id => new Promise(resolve => {
        const getElement = () => {
            const element = document.getElementById(id);
            if (element) {
                resolve(element);
            } else {
                requestAnimationFrame(getElement);
            }
        };
        getElement();
    });

    // utlity  function for controlling rerendering
    const delay = ms => new Promise(res => setTimeout(res, ms));
    const handleSend = async (data) => {
      
      // get the filtered data
      var data = dimension.top(Infinity);
      // format the data as csv
      var blob = new Blob([d3.csvFormat(data)], {type: "text/csv;charset=utf-8"});

        // create a new form data and append the blob
      const formData = new FormData();
   
        formData.append("data.csv", blob);



        // test async
        async function getEl() {
            const divElement = await getElementByIdAsync('investment');
            if (divElement) {
                //console.log(divElement)
                d3.select("#investment").on("click", function (d) {
                    console.log("i have been  clicked")
                    axios.post("https://kim-ims.azurewebsites.net/Email/SendEmail", formData).then((res) => {
                        alert("your request has been sent, pending review")
                        window.ADMINLEVEL = undefined
                        window.IFINANCESTREAM = undefined
                        window.IVALUECHAINS= undefined
                    })
                });
                
            }
        }
       
        //await delay(30000) // wait for 5 second for reat component to  render 
        // console.log("waited for 1 minute")                 // then listen to  onclick event on send request button  
        
        getEl()
    };


  d3.select("#download").on("click", function(){
      if (typeof window.ADMINLEVEL === 'undefined') {
          //console.log("wrong sele: adminbound")
      } else if (typeof window.IFINANCESTREAM === 'undefined') {
          //console.log("wrong sele: Enterprise")
      } else if (typeof window.IVALUECHAINS === 'undefined') {
          //console.log("wrong sele: value")
      } else {
          handleSend()
      }
  });

  return nasdaqTable;
};
const style = css({
  "& tr": {
    "&:hover": {
      background: "#dddd",
    },
  },
  "& td": {
    // padding:rhythm(0.1),
    textAlign: "left",
    borderTop: "1px solid #ddd",
  },
});
export const Desc = (props) => (
  <ChartTemplate
    chartFunction={descChartFunc}
    title="Description of Investment Opportunities"
  />
);
